<template>
    <div class="t_content_view">
        <el-tabs v-model="activeTab" class="t_kh_tabs">
            <el-tab-pane label="客户列表" name="list"></el-tab-pane>
            <el-tab-pane label="打标任务" name="task"></el-tab-pane>
        </el-tabs>
        <div v-show="activeTab === 'list'">
        <div class="t_search_box" >
            <div class="t_search_select">
                <span style="color: #6D6D6D;">企微主体：</span>
                <el-select style="width: 180px;"  size="small" v-model="searchdata.corp_ids" multiple clearable placeholder="请选择">
                   
                    <el-option v-for="(item,index) in corpList.data" 
                    :key="index"
                    :label="item.corp_name" :value="item.id" />
                </el-select>
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">资源账号：</span>
                <el-select style="width: 180px;" size="small" multiple collapse-tags v-model="searchdata.add_by"  clearable placeholder="请选择" filterable>
                    <el-option v-for="(item,index) in allpeolist.data" 
                    :key="index"
                    :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">添加方式：</span>
                <el-select style="width: 180px;" size="small" multiple collapse-tags v-model="searchdata.add_way"  clearable placeholder="请选择">
                    <el-option v-for="(item,index) in allqdtypelist.data" :key="index" :label="item.title" :value="item.id" />
                </el-select>
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">来源渠道：</span>
                <el-select style="width: 180px;" size="small" v-model="searchdata.source"
                  clearable placeholder="请选择">
                    <el-option v-for="(item,index) in allqdlist.data" 
                    :key="index"
                    :label="item" 
                    :value="item" />
                </el-select>
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">单向好友：</span>
                <el-select style="width: 180px;"  size="small" v-model="searchdata.status" clearable placeholder="请选择">
                    <el-option  :key="0" label="双向客户" :value="0" />
                    <el-option  :key="1" label="单向客户" :value="1" />
                </el-select>
            </div>
            <div class="t_search_select" >
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input  size="small" v-model="searchdata.name" placeholder="请输入名称或手机号"  clearable />
            </div>
            <div class="t_search_select" >
                <el-input type="number" min="0" size="small" v-model="searchdata.age_start" placeholder="请输入起始年龄"  clearable />
                <span style="color: #6D6D6D;">至</span>
                <el-input type="number" min="0" size="small" v-model="searchdata.age_end" placeholder="请输入结束年龄"  clearable />
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">是否对齐：</span>
                <el-select style="width: 180px;"  size="small" v-model="searchdata.alignment_user" clearable placeholder="请选择">
                    <el-option  :key="1" label="是" :value="1" />
                    <el-option  :key="0" label="否" :value="0" />
                </el-select>
            </div>
            <div class="t_search_select" >
                <span style="color: #6D6D6D;">好友添加时间：</span>
                <el-date-picker
                    size="small" 
                    v-model="searchdate"
                    type="datetimerange"
                    @change="changedate"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    :default-time="defaultTime.data"
                />
            </div>
            <div class="t_search_select" >
                <span style="color: #6D6D6D;">流失时间：</span>
                <el-date-picker
                    size="small" 
                    v-model="lostsearchdate"
                    type="datetimerange"
                    @change="changelostdate"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    :default-time="defaultTime.data"
                />
            </div>
            <el-button @click="resbtn" color="#F1F3F9" style="margin-bottom: 10px;" type="primary">重置</el-button>
            <el-button @click="searchbtn" color="#F1F3F9" style="margin-bottom: 10px;" type="primary">搜索</el-button>
        </div>

        <div class="t_search_box" style="display:block">
            <div class="t_heng_search" style="align-items: flex-start;">
                <div class="t_heng_title">标签分类：</div>
                <div class="t_fen_box">
                    <div  class="t_heng_tag" @click="changealltagtype" :class="{'t_heng_tag_lei':searchdata.group_ids.length==0}" >全部</div>
                    <div @click="changeTagType(item.id)" v-for="(item,index) in bqtypeList.data" :key="index" class="t_heng_tag" :class="{'t_heng_tag_lei':searchdata.group_ids.indexOf(item.id)!=-1}">{{item.cate_name}}</div>
                </div>
            </div>
            <div class="t_heng_search"  style="align-items: flex-start;">
                <div class="t_heng_title">客户标签：</div>
                <div class="t_fen_box">
                    <div  class="t_heng_tag" @click="changeallbalist" :class="{'t_heng_tag_lei':searchdata.labels.length==0}" >全部</div>
                    <div @click="changeTag(item.id)" v-for="(item,index) in bqList.data" :key="index" class="t_heng_tag" :class="{'t_heng_tag_lei':searchdata.labels.indexOf(item.id)!=-1}">{{item.tag_name}}</div>
                </div>
            </div>
            <div class="t_heng_search">
                <div class="t_heng_title">用户属性：</div>
                <div class="t_search_select" style="margin-bottom: 0px;">
                    <el-select style="width: 80px;" @change="changesex" size="small" v-model="searchdata.gender" clearable placeholder="性别">
                        <el-option  :key="0" label="未知" :value="0" />
                        <el-option  :key="1" label="男性" :value="1" />
                        <el-option  :key="2" label="女性" :value="2" />
                    </el-select>
                </div>
                <div class="t_search_select" style="margin-bottom: 0px;">
                    <el-select style="width: 100px;"  @change="changeaddtime" size="small" v-model="searchdata.add_time" clearable placeholder="添加时长">
                        <el-option label="一周内" :value="0"></el-option>
                        <el-option label="一个月内" :value="1"></el-option>
                        <el-option label="三个月内" :value="2"></el-option>
                        <el-option label="半年内" :value="3"></el-option>
                        <el-option label="一年内" :value="4"></el-option>
                        <el-option label="超过一年" :value="5"></el-option>
                        
                    </el-select>
                </div>
                <div class="t_search_select" style="margin-bottom: 0px;">
                    <el-select style="width: 80px;" @change="changesheng" size="small" v-model="searchdata.province" clearable placeholder="地域">
                        <el-option label="北京市" value="北京市"></el-option>
                        <el-option label="天津市" value="天津市"></el-option>
                        <el-option label="河北省" value="河北省"></el-option>
                        <el-option label="山西省" value="山西省"></el-option>
                        <el-option label="内蒙古自治区" value="内蒙古自治区"></el-option>
                        <el-option label="辽宁省" value="辽宁省"></el-option>
                        <el-option label="吉林省" value="吉林省"></el-option>
                        <el-option label="黑龙江省" value="黑龙江省"></el-option>
                        <el-option label="上海市" value="上海市"></el-option>
                        <el-option label="江苏省" value="江苏省"></el-option>
                        <el-option label="浙江省" value="浙江省"></el-option>
                        <el-option label="安徽省" value="安徽省"></el-option>
                        <el-option label="福建省" value="福建省"></el-option>
                        <el-option label="江西省" value="江西省"></el-option>
                        <el-option label="山东省" value="山东省"></el-option>
                        <el-option label="河南省" value="河南省"></el-option>
                        <el-option label="湖北省" value="湖北省"></el-option>
                        <el-option label="湖南省" value="湖南省"></el-option>
                        <el-option label="广东省" value="广东省"></el-option>
                        <el-option label="广西壮族自治区" value="广西壮族自治区"></el-option>
                        <el-option label="海南省" value="海南省"></el-option>
                        <el-option label="重庆市" value="重庆市"></el-option>
                        <el-option label="四川省" value="四川省"></el-option>
                        <el-option label="贵州省" value="贵州省"></el-option>
                        <el-option label="云南省" value="云南省"></el-option>
                        <el-option label="西藏自治区" value="西藏自治区"></el-option>
                        <el-option label="陕西省" value="陕西省"></el-option>
                        <el-option label="甘肃省" value="甘肃省"></el-option>
                        <el-option label="青海省" value="青海省"></el-option>
                        <el-option label="宁夏回族自治区" value="宁夏回族自治区"></el-option>
                        <el-option label="新疆维吾尔自治区" value="新疆维吾尔自治区"></el-option>
                        <el-option label="台湾省" value="台湾省"></el-option>
                        <el-option label="香港特别行政区" value="香港特别行政区"></el-option>
                        <el-option label="澳门特别行政区" value="澳门特别行政区"></el-option>
                    </el-select>
                </div>
            </div>
            
        </div>
  
        <el-dropdown class="t_add_people" style="margin-right: 10px;" :disabled="morepeolist.data.length==0"  @command="handleCommand">
            <el-button color="#4F46E5" :disabled="morepeolist.data.length==0"  type="primary">
                批量设置标签<el-icon class="el-icon--right"><arrow-down /></el-icon>
            </el-button>
            <template #dropdown>
                <el-dropdown-menu>
                    <el-dropdown-item   command="pltj">批量添加标签</el-dropdown-item>
                    <el-dropdown-item   command="plsc">批量删除标签</el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
        <el-button v-if="issearch" @click="daochu" color="#4F46E5" class="t_add_people" type="primary"  >导出</el-button>
        <el-button class="t_add_people" @click="checkdaochu" color="#F1F3F9"  type="primary">导出记录</el-button>
        <el-button class="t_add_people" @click="opentagbatch" color="#4F46E5"  type="primary">按条件批量打标</el-button>
        <!-- <el-button color="#4F46E5" @click="tbkhbtn" class="t_add_people" type="primary"  >同步客户</el-button> -->

        <div v-if="!issearch" style="text-align: center;font-size: 15px;color: #909399;line-height: 200px;">请先选择搜索条件，点击搜索按钮进行搜索</div>
        <el-table v-if="issearch" :header-cell-style="{ background: '#F1F3F9' }" 
        :data="tableData.data" 
        @selection-change="handleSelectionChange"
        style="width: 100%" v-loading="loading">
            <el-table-column type="selection" width="55" ></el-table-column>
            <el-table-column label="用户" min-width="130">
                <template #default="scope">
                    <div class="t_head_box">
                        <img v-if="scope.row.avatar==''" style="width:30px;height: 30px;border-radius: 50%;margin-right:5px"
                            src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fi-1.lanrentuku.com%2F2020%2F11%2F5%2Fdef6ed04-6d34-402e-99c8-366266f627dd.png%3FimageView2%2F2%2Fw%2F500&refer=http%3A%2F%2Fi-1.lanrentuku.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1656658303&t=a072b62edba2f32969f8159adbc2ec2c" alt="">
                        <img v-else style="width:30px;height: 30px;border-radius: 50%;margin-right:5px"
                            :src="scope.row.avatar" alt="">
                        <div>
                            <div>{{ scope.row.name }}</div>
                            <!-- <div>昵称:{{ scope.row.alias }}</div> -->
                        </div>
                        
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="tage" label="用户标签" min-width="200">
                <template #default="scope">
                    <div class="t_tag_cell">
                        <el-tag v-for="(item,index) in (scope.row.labels || []).slice(0, 2)" :key="index" type="success">{{item.title}}</el-tag>
                        <el-tooltip v-if="(scope.row.labels || []).length > 2" placement="top" effect="light">
                            <template #content>
                                <div class="t_tag_tooltip">
                                    <el-tag v-for="(item,index) in scope.row.labels.slice(2)" :key="index" type="success">{{item.title}}</el-tag>
                                </div>
                            </template>
                            <el-tag class="t_tag_more" type="info">+{{ scope.row.labels.length - 2 }}</el-tag>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号" min-width="120" />
            <el-table-column prop="remark_mobiles" label="聊天客服备注手机号" min-width="160" />
            <el-table-column label="企微主体" min-width="140">
                <template #default="scope">
                    {{ getcorpname(scope.row.corp_id) }}
                </template>
            </el-table-column>
            <el-table-column prop="add_uer_name" label="添加人（坐席）" min-width="130" />
            <el-table-column prop="add_way" label="添加方式" min-width="110">
                <!-- <template #default="scope">
                    <div v-if="scope.row.addWay==0">未知来源</div>
                    <div v-if="scope.row.addWay==1">扫描二维码</div>
                    <div v-if="scope.row.addWay==2">搜索手机号</div>
                    <div v-if="scope.row.addWay==3">名片分享</div>
                    <div v-if="scope.row.addWay==4">群聊</div>
                    <div v-if="scope.row.addWay==5">手机通讯录</div>
                    <div v-if="scope.row.addWay==6">微信联系人</div>
                    <div v-if="scope.row.addWay==8">安装第三方应用时自动添加的客服人员</div>
                    <div v-if="scope.row.addWay==9">搜索邮箱</div>
                    <div v-if="scope.row.addWay==10">视频号添加</div>
                    <div v-if="scope.row.addWay==11">通过日程参与人添加</div>
                    <div v-if="scope.row.addWay==12">通过会议参与人添加</div>
                    <div v-if="scope.row.addWay==13">添加微信好友对应的企业微信</div>
                    <div v-if="scope.row.addWay==14">通过智慧硬件专属客服添加</div>
                    <div v-if="scope.row.addWay==15">通过上门服务客服添加</div>
                    <div v-if="scope.row.addWay==16">通过获客链接添加</div>
                    <div v-if="scope.row.addWay==17">通过定制开发添加</div>
                    <div v-if="scope.row.addWay==18">通过需求回复添加</div>
                    <div v-if="scope.row.addWay==201">内部成员共享</div>
                    <div v-if="scope.row.addWay==202">管理员/负责人分配</div>
                    <div v-if="scope.row.addWay==301">聚合码</div>
                    <div v-if="scope.row.addWay==302">加人任务</div>
                    
                </template> -->
            </el-table-column>
            <el-table-column prop="addWay" label="单向好友" width="90">
                <template #default="scope">
                    <div v-if="scope.row.status==0">否</div>
                    <div v-if="scope.row.status==1">是</div>
                </template>
            </el-table-column>
            <el-table-column prop="addWay" label="是否对齐" width="90">
                <template #default="scope">
                    <div v-if="scope.row.alignment_user==1">是</div>
                    <div v-else>否</div>
                </template>
            </el-table-column>
            <el-table-column prop="add_time" label="添加时间" min-width="170" />
            <el-table-column label="操作" width="110" fixed="right">
                <template #default="scope">
                    <el-button size="small"
                    style="color:#4F46E5" 
                    type="text" @click="opendetail(scope.row)">客户详情</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagechange v-if="issearch" :total="total" :nowpage="searchdata.page" @page_change="page_change" />
        </div>
        <tagtask v-if="activeTab === 'task'" />
    </div>
    <!-- 客户详情 -->
    <el-dialog
        v-model="infoshow"
        title="客户详情"
        width="90%"
    >
        <el-descriptions direction="vertical"
        border :column="descColumn" class="t_kh_detail_desc" >
            <el-descriptions-item label="添加时间">{{peoinfodata.data.add_time}}</el-descriptions-item>
            <el-descriptions-item label="添加方式">
                {{ peoinfodata.data.add_way }}
            </el-descriptions-item>
            <el-descriptions-item label="外部联系人头像">{{peoinfodata.data.avatar}}</el-descriptions-item>
            <el-descriptions-item label="企微主体">
                {{peoinfodata.data.corp_name}}
            </el-descriptions-item>
            <el-descriptions-item label="添加人（坐席）"
            >{{peoinfodata.data.add_uer_name}}</el-descriptions-item>
            <el-descriptions-item label="创建时间"
            >{{peoinfodata.data.add_time}}</el-descriptions-item>
            <el-descriptions-item label="外部联系人性别"
            >
                 {{peoinfodata.data.gender}}
            </el-descriptions-item>
            <el-descriptions-item label="外部联系人的名称"
            >{{peoinfodata.data.name}}</el-descriptions-item>
            <el-descriptions-item label="备注"
            >{{peoinfodata.data.remarks}}</el-descriptions-item>
            <el-descriptions-item label="外部联系人的类型">
                {{peoinfodata.data.type}}
            </el-descriptions-item>
            <!-- <el-descriptions-item label="修改人"
            >{{peoinfodata.data.updateBy}}</el-descriptions-item>
            <el-descriptions-item label="修改时间"
            >{{peoinfodata.data.updateTime}}</el-descriptions-item>
            <el-descriptions-item label="添加成员姓名">{{peoinfodata.data.userName}}</el-descriptions-item> -->
        </el-descriptions>
        <div v-if="peoinfodata.data.info" style="margin-top: 20px;margin-bottom: 10px;font-weight: bold;">敢探号订单</div>
        <el-table v-if="peoinfodata.data.info" :data="peoinfodata.data.info.order" border style="width: 100%">
            <el-table-column prop="order_id" label="订单ID"  />
            <el-table-column prop="ordered_at" label="下单时间"  />
            <el-table-column prop="product_sku" label="商品名称" />
            <el-table-column prop="source_sku" label="商品编码" />
            <el-table-column prop="plan_mobile_produced" label="生产号码" />
            <el-table-column prop="address_name" label="收件人" />
            <el-table-column prop="address_mobile" label="联系电话" />
            <el-table-column  label="收货地址" >
                <template #default="scope">
                    {{ scope.row.address_province }}
                    {{ scope.row.address_city }}
                    {{ scope.row.address_district }}
                    {{ scope.row.address }}
                </template>
            </el-table-column>
            <el-table-column prop="order_status_name" label="订单状态" />
            <el-table-column prop="active_status_name" label="激活状态" />
        </el-table>
    </el-dialog>
       <!-- 选择标签 -->
    <el-dialog v-model="isqdtag" @closed="closeTag" title="选择渠道标签" width="1200px" >
        <div class="t_tagchoose_box" v-for="(item,index) in bqData.data" :key="index">
            <div>{{item.cate_name}}</div>
            <div>
                <el-check-tag  v-for="(item2,index2) in item.tags" :key="index2" 
                class="t_all_tag"
                :checked="item2.checked" @change="onChange(index,index2)">{{item2.tag_name}}</el-check-tag>
            </div>
        </div>
        <div class="t_cz_box">
            <el-button color="#4F46E5" @click="choosesub" type="primary">确定</el-button>
        </div>
    </el-dialog>
    <!-- 导出记录查看 -->
    <el-dialog
        v-model="isshowcheckoutdaochu"
        title="导出记录"
        width="768px">
       <!-- <div style="margin-bottom:30px" >
            <el-input style="width: 258px;margin-right: 20px;" class="t_dig_daochu_box" v-model="searchdata.phone" placeholder="按昵称查找"  clearable />
            <el-button  color="#4F46E5"  type="primary"  >查询</el-button>
            <el-button  color="#F1F3F9"  type="primary">刷新</el-button>
       </div> -->
       <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="chaochulist.data" style="width: 100%">
            <el-table-column prop="created_at" align="center" label="导出时间"  />
            <el-table-column prop="createBy" align="center" label="操作账号"  >
                <template #default="scope">
                    <span v-if="scope.row.status==0">待执行</span>
                    <span v-if="scope.row.status==1">执行中</span>
                    <span v-if="scope.row.status==2">执行完成</span>
                    <span v-if="scope.row.status==3">执行失败</span>
                    
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template #default="scope">
                    <el-button
                    v-if="scope.row.status==2"
                    size="small"
                    type="text"
                    style="color:#4F46E5" 
                    @click="handledown( scope.row.local_path)"
                    >
                    下载
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
            <el-button @click="isshowcheckoutdaochu = false">取消</el-button>
            <el-button type="primary" color="#4F46E5"  @click="isshowcheckoutdaochu = false">
            确认
            </el-button>
        </div>
    </el-dialog>
    <!-- 按条件批量打标 -->
    <el-dialog v-model="tagbatch.show" title="按条件批量打标" width="640px">
        <div class="t_tagbatch_tip">
            打标条件跟随当前客户列表的筛选条件。客户列表按好友关系统计，同一客户被多个客服添加会显示多行；打标按客户去重，当前共
            <span class="t_tagbatch_num">{{ tagbatch.count }}</span>
            个客户，其中
            <span class="t_tagbatch_num">{{ tagbatch.pending }}</span>
            个待打标。
        </div>
        <el-form label-width="90px">
            <el-form-item label="打标主体">
                <span>{{ tagbatch.corp_names }}</span>
            </el-form-item>
            <el-form-item label="目标标签" required>
                <el-select style="width: 100%;" v-model="tagbatch.tag_ids" multiple filterable clearable placeholder="请选择要添加的标签">
                    <el-option v-for="(item,index) in bqDataselect.data" :key="index" :label="item.tag_name" :value="item.id" />
                </el-select>
            </el-form-item>
        </el-form>
        <div class="t_cz_box">
            <el-button @click="tagbatch.show = false">取消</el-button>
            <el-button color="#4F46E5" type="primary" :loading="tagbatch.submitting" @click="submittagbatch">确定打标</el-button>
        </div>
    </el-dialog>
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, onUnmounted, watch,inject } from 'vue'
import { ElMessage,ElMessageBox } from 'element-plus'
//导入子组件
import pagechange from '../components/pagechange.vue'
import tagtask from './tagtask.vue'
import { khlist,qdtypelist,qdmlist,bqlist,tbkh,pladd,pldel ,khdetail,khdaochu,khdownlist,newekhlist,newekhdetail,newekhlistexport,newekhexport,newgetway,newgetsource,newgettaglist,newgetpeo,newechangekhtag,newgetcomp2,newgetbqtypev2,newgetbqlistv2,newtagcount,newtagtaskcreate} from '@/assets/js/common.js'
//动态获取接口地址
const _url2 = inject('_url2')
//客户管理页签：客户列表 / 打标任务
const activeTab = ref('list')
//客户详情列数：窄屏减少列数，避免内容把弹窗撑开
const descColumn = ref(3)
const setDescColumn = () => {
    if (window.innerWidth < 768) {
        descColumn.value = 1
    } else if (window.innerWidth < 1200) {
        descColumn.value = 2
    } else {
        descColumn.value = 3
    }
}
onMounted(() => {
    console.log('onMounted')
    setDescColumn()
    window.addEventListener('resize', setDescColumn)
    //获取列表
    // getlist()
    //获取所有成员下拉
    getallpeolist()
    //渠道类别列表，用于下拉
    getqdtypelist()
    //获取所有渠道下拉
    getallqdlist()
    //获取标签列表
    getbqlist()
    //获取企微主体下拉
    getcorplist()
    //获取标签分类
    getbqv2()
    //获取客户标签
    getkhbqv2()
})

onUnmounted(() => {
    window.removeEventListener('resize', setDescColumn)
})


//标签分类
const bqtypeList = reactive({
    data:[]
})
//获取标签分类
const getbqv2 = ()=>{
    newgetbqtypev2().then((response)=>{
        if (response.data.msg.code == 0) {
            bqtypeList.data = response.data.data
            console.log('获取标签分类v2')
            console.log(bqtypeList.data)
        }
    })
}
//切换标签分类
const changeTagType = (id)=>{
    console.log(id)
    //判断是否存在，不存在写入，存在删除
    if(searchdata.group_ids.indexOf(id)==-1){
        searchdata.group_ids.push(id)
    }else{
        searchdata.group_ids = searchdata.group_ids.filter(item=>item!=id)
    }
    searchdata.page=1
    getkhbqv2()
    // getlist()
}
//切换全部标签分类
const changealltagtype = ()=>{
    searchdata.group_ids = []
    searchdata.page=1
    getkhbqv2()
    // getlist()
}




//客户标签
const bqList = reactive({
    data:[]
})
//获取客户标签
const getkhbqv2 = ()=>{
    newgetbqlistv2({tag_group_id:searchdata.group_ids.toString()}).then((response)=>{
        if (response.data.msg.code == 0) {
            bqList.data = response.data.data
            changeallbalist()
            console.log('获取客户标签v2')
            console.log(bqList.data)
        }
    })
}
//切换客户标签
const changeTag = (id)=>{
    console.log(id)
    //判断是否存在，不存在写入，存在删除
    if(searchdata.labels.indexOf(id)==-1){
        searchdata.labels.push(id)
    }else{
        searchdata.labels = searchdata.labels.filter(item=>item!=id)
    }
    searchdata.page=1
    // getlist()
}
//切换全部客户标签
const changeallbalist = ()=>{
    searchdata.labels = []
    searchdata.page=1
    // getlist()
}


//企微主体下拉
const corpList = reactive({
    data:[]
})
//获取企微主体下拉
const getcorplist = ()=>{
    newgetcomp2().then((response)=>{
        if (response.data.msg.code == 0) {
            corpList.data = response.data.data
            console.log('企微主体下拉')
            console.log(corpList.data)
        }
    })
}
//根据 corp_id 匹配企微主体名称
const getcorpname = (corpId)=>{
    var corp = corpList.data.find(function(item){
        return String(item.id) === String(corpId)
    })
    return corp ? corp.corp_name : '--'
}



// 全部标签
const bqData = reactive({
    data:[]
})
// 全部标签下拉
const bqDataselect = reactive({
    data:[]
})
//获取标签列表
const getbqlist = ()=>{
    newgettaglist().then((response)=>{
        bqDataselect.data = []
        if (response.data.msg.code == 0) {
            bqData.data = response.data.data
            //添加是否选中状态
            for(var i=0;i<bqData.data.length;i++){
                for(var x=0;x<bqData.data[i].tags.length;x++){
                    bqData.data[i].tags[x].checked=false
                    bqDataselect.data.push(bqData.data[i].tags[x])
                }
            }
            console.log('所有标签')
            console.log(bqData.data)
            console.log(bqDataselect.data)
        }
        // console.log(bqData.data)
    })
}
//切换标签选中事件
const onChange = (i1,i2)=>{
    if(nowdbqtype.value=='pltj'){
        //批量添加
        bqData.data[i1].tags[i2].checked=!bqData.data[i1].tags[i2].checked
        
    }else if(nowdbqtype.value=='plsc'){
        //批量删除
        //循环delstart.data
        for(var y = 0;y<delstart.data.length;y++){
            console.log(delstart.data[y].id)
            console.log(bqData.data[i1].tags[i2].id)
            if(delstart.data[y].id==bqData.data[i1].tags[i2].id){
                //可正常操作
                bqData.data[i1].tags[i2].checked=!bqData.data[i1].tags[i2].checked
            }
        }
    }
    
}
//当前打标签种类
const nowdbqtype = ref('')
//选择批量打标签或取消标签
const handleCommand = (val)=>{
  nowdbqtype.value = val
  choosetag()
}

//选择渠道标签弹窗
const isqdtag = ref(false)
//关闭标签弹窗
const closeTag = ()=>{
    getbqlist()
}
//批量删除标签-起始标签
const delstart = reactive({
    data:[]
})
const choosetag = ()=>{
    
    // console.log(nowdbqtype.value)
    isqdtag.value=true
    //判断是添加还是删除
    if(nowdbqtype.value=='pltj'){
        //批量添加
        
        
    }else if(nowdbqtype.value=='plsc'){
        
        //批量删除
        //通过选中的id获取标签列表
       
        delstart.data = []
        for(var i = 0;i<tableData.data.length;i++){
            for(var x = 0;x<morepeolist.data.length;x++){
                if(tableData.data[i].id==morepeolist.data[x]){
                    
                    for(var y = 0;y<tableData.data[i].labels.length;y++){

                        delstart.data.push(tableData.data[i].labels[y])   
                    }
                    
                }
            }
        }

        
        
        //数组去重
        for (let i = 0; i < delstart.data.length; i++) {
            for (let j = i + 1; j < delstart.data.length; j++) {
                if (delstart.data[i].id == delstart.data[j].id) {
                    delstart.data.splice(j, 1);
                    j--;
                }
            }
        }

       
        //将选中的设置为true
        for(var i=0;i<bqData.data.length;i++){
            for(var x=0;x<bqData.data[i].tags.length;x++){
                //循环delstart.data
                for(var y = 0;y<delstart.data.length;y++){
                    if(delstart.data[y].id==bqData.data[i].tags[x].id){
                        //设置为选中状态
                        bqData.data[i].tags[x].checked=true
                    }
                }
            }
        }
        console.log('0---')
        console.log(delstart.data)
        console.log('0---')
       
        
    }
}
//选中的标签数组
const choosedtag = reactive({
    data:[]
})
//确定选择
const choosesub = ()=>{
    

    //判断是添加还是删除
    if(nowdbqtype.value=='pltj'){

        choosedtag.data=[]
        //批量添加
        for(var i=0;i<bqData.data.length;i++){
            for(var x=0;x<bqData.data[i].tags.length;x++){
                if(bqData.data[i].tags[x].checked){
                    choosedtag.data.push(bqData.data[i].tags[x].id)
                }
            }
        }
        
        // console.log(choosedtag.data.toString())
        // console.log(morepeolist.data.toString())
        newechangekhtag(
        {
            type:1,
            labels:choosedtag.data,
            ids:morepeolist.data,
        }).then((response)=>{
            if (response.data.msg.code == 0) {
                ElMessage({
                    message: '修改成功！',
                    type: 'success',
                })
                getlist()
            }
        })
    }else if(nowdbqtype.value=='plsc'){
        //批量删除
        //判断当前选中的标签
        for(var i=0;i<bqData.data.length;i++){
                for(var x=0;x<bqData.data[i].tags.length;x++){
                    if(bqData.data[i].tags[x].checked){
                        //从删除的起始标签中删除元素
                        for(var y = 0;y<delstart.data.length;y++){
                           if(delstart.data[y].id==bqData.data[i].tags[x].id){
                                delstart.data.splice(y,1)
                            }
                            
                        }
                    }
                }
            }
        
        // 删除的标签id
        var delid = []
        for(var i = 0;i<delstart.data.length;i++){
            delid.push(delstart.data[i].id)
        }
        // console.log(delid.toString())
        // console.log(morepeolist.data.toString())

        newechangekhtag(
        {
            type:2,
            labels:delid,
            ids:morepeolist.data,
        }).then((response)=>{
            if (response.data.msg.code == 0) {
                ElMessage({
                    message: '删除成功！',
                    type: 'success',
                })
                getlist()
            }
        })
       
        

    }
    isqdtag.value=false
    
    
}
//搜索
//搜索1数据
const search1 = ref('')


//输入框搜索
const searchname = ref('')

//搜索
const searchdata = reactive({
   //当前页
    page:1,
    page_size:20,
    corp_ids:'',
    add_by:[],
    add_way:[],
    source:'',
    status:'',
    name:'',
    start_time:'',
    end_time:'',
    lost_start_time:'',
    lost_end_time:'',
    gender:'',
    add_time:'',
    province:'',
    age_start:'',
    age_end:'',
    group_ids:[],
    labels:[],
    alignment_user:'',
    
    // add_way:'',
    // way_name:'',
    
    // labels:'',
    
    
    // corpId:$cookies.get("fanscorpId")
})
//按条件批量打标
const tagbatch = reactive({
    show:false,
    count:0,
    pending:0,
    corp_names:'',
    tag_ids:[],
    submitting:false
})
//打标条件跟随当前列表筛选条件
const buildbatchparams = ()=>{
    var obj = JSON.parse(JSON.stringify(searchdata));
    delete obj.page;
    delete obj.page_size;
    if(Array.isArray(searchdata.corp_ids)){
        obj.corp_ids = searchdata.corp_ids
    }else{
        obj.corp_ids = searchdata.corp_ids ? [searchdata.corp_ids] : []
    }
    return obj
}
//打开打标弹窗，先试算当前列表命中数量
const opentagbatch = ()=>{
    tagbatch.show = true
    tagbatch.tag_ids = []
    tagbatch.count = 0
    tagbatch.pending = 0
    tagbatch.submitting = false
    var corpIds = buildbatchparams().corp_ids
    if(corpIds.length == 0){
        tagbatch.corp_names = '全部授权主体'
    }else{
        tagbatch.corp_names = corpList.data
            .filter(item=>corpIds.map(String).indexOf(String(item.id)) != -1)
            .map(item=>item.corp_name).join('、')
    }
    newtagcount(buildbatchparams()).then((response)=>{
        if (response.data.msg.code == 0) {
            tagbatch.count = response.data.data.total
            tagbatch.pending = response.data.data.pending
        }else{
            ElMessage({
                message: response.data.msg.info || '获取打标数量失败',
                type: 'error',
            })
        }
    })
}
//提交按条件打标任务
const submittagbatch = ()=>{
    if(tagbatch.tag_ids.length == 0){
        ElMessage({
            message: '请选择要添加的标签',
            type: 'warning',
        })
        return
    }
    tagbatch.submitting = true
    var obj = buildbatchparams()
    obj.tag_ids = tagbatch.tag_ids
    newtagtaskcreate(obj).then((response)=>{
        tagbatch.submitting = false
        if (response.data.msg.code == 0) {
            ElMessage({
                message: '打标任务已创建，可在「打标任务」中查看进度',
                type: 'success',
            })
            tagbatch.show = false
        }else{
            ElMessage({
                message: response.data.msg.info || '创建打标任务失败',
                type: 'error',
            })
        }
    }).catch(()=>{
        tagbatch.submitting = false
    })
}
//重置
const resbtn = ()=>{
    searchdata.page = 1
    searchdata.corp_ids=''
    searchdata.add_by=[]
    searchdata.source=''
    searchdata.status=''
    searchdata.name=''
    searchdata.start_time=''
    searchdata.end_time=''
    searchdata.lost_start_time=''
    searchdata.lost_end_time=''
    searchdata.age_start=''
    searchdata.age_end=''
    searchdate.value=[]
    lostsearchdate.value=[]
    searchdata.alignment_user=''
    searchdata.add_way=[]
    searchdata.add_time=''
    searchdata.province=''
    searchdata.gender=''
    searchdata.group_ids=[]
    searchdata.labels=[]
    getkhbqv2()




    morepeo.data = []
    getlist()
}
//搜索
const searchbtn = ()=>{
    searchdata.page = 1
    getlist()
}
//搜索名称
const changename = (val)=>{
    searchdata.page=1
    searchdata.name=val
    // getlist()
}
//搜索性别下拉
const changesex = (val)=>{
    searchdata.page=1
    searchdata.gender=val
    // getlist()
}
//搜索添加时长下拉
const changeaddtime = (val)=>{
    searchdata.page=1
    searchdata.add_time=val
    // getlist()
}
//搜索流失状态变化
const changelost = (val)=>{
    console.log('流失状态：'+val)
    searchdata.page=1
    searchdata.status=val
    // getlist()
}
//选择成员多选
const morepeo = reactive({
    data:[]
})
//搜索添加成员变化
const changeaddpeo = (val)=>{
    
    
    searchdata.page=1
    searchdata.userName=val.join(',')
    // getlist()
}
//所有成员下拉数组
const allpeolist = reactive({
    data:[]
})
//获取所有成员下拉
const getallpeolist = ()=>{
    newgetpeo({include_disabled:1}).then((response)=>{
        if (response.data.msg.code == 0) {
            allpeolist.data = response.data.data
        }
    })
}
//搜索渠道类别变化
const changeaddqdtype = (val)=>{
    console.log('渠道类别：'+val)
    searchdata.page=1
    searchdata.addWay=val
    // getlist()
}
//搜索渠道类别下拉数据
const allqdtypelist = reactive({
    data:[]
})
//渠道类别列表，用于下拉
const getqdtypelist = ()=>{
    newgetway().then((response)=>{
        console.log(response)
        if (response.data.msg.code == 0) {
            allqdtypelist.data=response.data.data
        }
    })
}
//搜索渠道变化
const changeaddqd = (val)=>{
    console.log('渠道：'+val)
    searchdata.page=1
    searchdata.wayName=val
    // getlist()
}
//所有渠道下拉
const allqdlist = reactive({
    data:[]
})
//获取所有渠道下拉
const getallqdlist = ()=>{
    newgetsource().then((response)=>{
        if (response.data.msg.code == 0) {
            // console.log(response.data.result)
            allqdlist.data = response.data.data
        }
    })
}
//搜索省
const changesheng = (val)=>{
    searchdata.page=1
    searchdata.province=val
    // getlist()
}
//下拉选中的id
const changetagchooseid = ref('')
//搜索用户标签变化
const changetag = (val)=>{
    console.log('标签：'+val)
    console.log('标签：'+val.length)

    // if(val.length!=0){
        
    //     searchdata.labels = val.join(',')
    // }else{
    //     searchdata.labels = ''
    // }
    searchdata.labels = val
    searchdata.page=1
    // getlist()
}
//搜索手机号变化
const changephone = (val)=>{
    console.log(val)
    searchdata.page=1
    searchdata.phone=val
    // getlist()
}
//搜所日期
const searchdate = ref('')
//搜索日期变化
const changedate = (val)=>{
    console.log(val)
    // console.log(val[0])
    if(val){
        searchdata.start_time = val[0]
        searchdata.end_time = val[1]
    }else{
        searchdata.start_time = ''
        searchdata.end_time = ''
    }
    // searchdata.page=1
    // getlist()
}
//流失日期
const lostsearchdate = ref('')
//流失日期变化
const changelostdate = (val)=>{
    console.log(val)
    if(val){
        searchdata.lost_start_time = val[0]
        searchdata.lost_end_time = val[1]
    }else{
        searchdata.lost_start_time = ''
        searchdata.lost_end_time = ''
    }
    // searchdata.page=1
    // getlist()
}
//列表数据
const tableData = reactive({
    data:[]
})
//成员总数
const total = ref(0)
//加载中
const loading = ref(false)

//是否搜索过
const issearch = ref(false)

//获取客户管理列表
const getlist = ()=>{
    issearch.value = true
    loading.value = true
    var obj = JSON.parse(JSON.stringify(searchdata));
    obj.corp_ids = obj.corp_ids.toString()
    newekhlist(obj).then((response)=>{
        // console.log('----')
        // console.log(response.data.msg.code)
        if (response.data.msg.code == 0) {
            
            console.log('列表==')
            console.log(response.data)
            tableData.data=response.data.data.data
            total.value = response.data.data.total
            loading.value = false
        }
        loading.value = false
    })
}
//监听分页
const page_change = (val)=>{
    searchdata.page = val
    //人员列表
    getlist()
}
//多选选中的数据
const morepeolist = reactive({
    data:[]
})
//多选
const handleSelectionChange = (val)=>{
    console.log(val)
    morepeolist.data = []
    for(var i = 0;i<val.length;i++){
        morepeolist.data.push(val[i].id)
    }
    
    console.log(morepeolist.data)
}
//当前客户详情数据
const peoinfodata = reactive({
    data:[]
})

//客户详情弹窗
const infoshow = ref(false)
//打开详情弹窗
const opendetail = (row)=>{
    
    
    newekhdetail({id:row.id, relation_id:row.relation_id}).then((response)=>{
        if (response.data.msg.code == 0) {
           console.log(response.data)
           peoinfodata.data = response.data.data
           peoinfodata.data.add_way = peoinfodata.data.add_way || row.add_way
          //详情接口不返回主体信息，按列表行的 corp_id 补充
          peoinfodata.data.corp_name = getcorpname(row.corp_id)
          infoshow.value=true
        }
    })
}
//同步客户按钮
const tbkhbtn = ()=>{
    tbkh(_url2,{corp_id:$cookies.get("fanscorpId")}).then((response)=>{
        if (response.data.msg.code == 0) {
            ElMessage({
                message: '同步成功！',
                type: 'success',
            })
            // getlist()
        }
    })
}
//导出
const daochu = ()=>{
    console.log(searchdata)
    newekhlistexport(searchdata).then((response)=>{
        if (response.data.msg.code == 0) {
            ElMessage({
                message: '正在导出，请稍后在导出记录中下载',
                type: 'success',
            })
        }
    })
}

const defaultTime = reactive({
    data:[
        new Date(2000, 1, 1, 0, 0, 0),
        new Date(2000, 2, 1, 23, 59, 59),
    ]
})

//导出记录弹窗
const isshowcheckoutdaochu = ref(false)
const chaochulist = reactive({
    data:[]
  }
)
//打开导出记录
const checkdaochu = ()=>{
    newekhexport({page:1,page_size:200000}).then((response)=>{
        if (response.data.msg.code == 0) {
            console.log('导出记录')
            console.log(response.data)
            chaochulist.data = response.data.data.data
        }
    })
    isshowcheckoutdaochu.value = true
}
//导出记录-下载
const handledown = (url)=>{
   
    const a = document.createElement('a');
    a.setAttribute('download', '');
    a.setAttribute('href', url);
    a.click();
}

</script>
<style scoped>

.t_kh_tabs {
    margin-bottom: 10px;
}

:deep(.t_kh_tabs .el-tabs__item.is-active) {
    color: #4F46E5;
}

:deep(.t_kh_tabs .el-tabs__active-bar) {
    background-color: #4F46E5;
}

:deep( .t_search_box .el-input__wrapper) {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}

.t_add_people {
    margin-top: 20px;
    margin-bottom: 20px;
}

.t_tagbatch_tip {
    background-color: #F1F3F9;
    border-radius: 8px;
    padding: 10px 12px;
    margin-bottom: 16px;
    color: #4E5969;
}

.t_tagbatch_num {
    color: #4F46E5;
    font-weight: 600;
}

.t_cz_box {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
}

.t_head_box {
    display: flex;
    align-items: center;
}

.t_tag_cell {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px 10px;
}

.t_tag_more {
    cursor: pointer;
}

/* 客户详情：固定表格布局，长链接/长文本在单元格内换行，避免撑出弹窗 */
.t_kh_detail_desc :deep(.el-descriptions__table) {
    table-layout: fixed;
}

.t_kh_detail_desc :deep(.el-descriptions__content) {
    white-space: normal;
    word-break: break-all;
}

.t_tag_tooltip {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    max-width: 260px;
}

/* .t_content_view {
    padding: 20px;
} */
/* .t_cz_box{
    display: flex;
    justify-content: flex-end;
} */
.t_all_tag{
    margin-top: 10px;
    margin-right: 10px;
}
.t_tagchoose_box{
    margin-bottom:30px
}
:deep( .t_dig_daochu_box  .el-input__wrapper){
    background-color: #F1F3F9 !important;
    border: none !important;
    box-shadow:0 0 0 0
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
.t_heng_search{
    display: flex;
    align-items: center;
    font-size: 15px;
    margin-bottom: 20px;
    margin-top: 20px;
    color:#4E5969;
}
.t_fen_box{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.t_heng_tag{
    padding: 5px 8px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 5px;
    margin-bottom: 5px;
}
.t_heng_title{
    width: 100px;
    flex-shrink: 0;
}
.t_heng_tag_lei{
    color:#1664FF;
    background-color: #F2F3F8;

}
</style>